export const translations = {
    en: {
        // Navigation
        'home': 'Home',
        'about': 'About',
        'tokenomics': 'Tokenomics',
        'roadmap': 'Roadmap',
        'team': 'Team',
        'contact': 'Contact',
        'buy_now': 'Buy Now',
        
        // Hero Section
        'hero_title': 'Welcome to QuokkaCoin',
        'hero_subtitle': 'The next generation cryptocurrency',
        
        // About Section
        'about_title': 'About QuokkaCoin',
        'about_description': 'QuokkaCoin is a revolutionary cryptocurrency designed for the future.',
        
        // Tokenomics Section
        'tokenomics.title': 'Token Economics',
        'tokenomics.description': 'Dive deeper into the QuokkaX token structure and explore the economic model behind your investment',
        'tokenomics.total_supply': 'Total Supply',
        'tokenomics.tokens': 'QUOKKA Tokens',
        'tokenomics.buy_tax': 'Buy Tax',
        'tokenomics.sell_tax': 'Sell Tax',
        'tokenomics.presale': 'Presale',
        'tokenomics.liquidity': 'Liquidity',
        'tokenomics.marketing': 'Marketing',
        'tokenomics.team': 'Team',
        'tokenomics.distribution': 'Token Distribution',
        'tokenomics.transparent': 'Transparent & Fair Distribution',
        'tokenomics.total': 'Total',
        'tokenomics.details': 'Token Details',
        'tokenomics.additional_info': 'Additional Information',
        'tokenomics.token_name': 'Token Name',
        'tokenomics.token_symbol': 'Token Symbol',
        'tokenomics.initial_price': 'Initial Price',
        'tokenomics.blockchain': 'Blockchain',
        'tokenomics.tax': 'Tax',
        'tokenomics.presale_allocation': 'Presale Allocation',
        'tokenomics.presale_allocation_desc': '40% of total supply available during presale phase',
        'tokenomics.liquidity_lock': 'Liquidity Lock',
        'tokenomics.liquidity_lock_desc': 'Platform liquidity locked to ensure project stability',
        'tokenomics.vesting_period': 'Vesting Period',
        'tokenomics.vesting_period_desc': '6-month cliff with 12-month linear vesting',
        'tokenomics.token_utility': 'Token Utility',
        'tokenomics.token_utility_desc': 'Governance, staking, NFT access and ecosystem rewards',
        'tokenomics.ecosystem': 'Ecosystem',
        'tokenomics.reserves': 'Reserves',
        'tokenomics.ecosystem_desc': 'Funds allocated for ecosystem development and growth',
        'tokenomics.reserves_desc': 'Strategic reserves for future development and partnerships',
        'tokenomics.presale_desc': 'Tokens allocated for the presale phase',
        'tokenomics.liquidity_desc': 'Tokens locked for liquidity provision',
        'tokenomics.marketing_desc': 'Funds allocated for marketing and promotion',
        'tokenomics.team_desc': 'Tokens allocated for team development and rewards',
        
        // Roadmap Section
        'roadmap_title': 'Roadmap',
        'roadmap_description': 'Our journey and future plans',
        'roadmap.title': 'Roadmap',
        'roadmap.presale': 'Presale',
        'roadmap.certik_audit': 'CertiK Audit',
        'roadmap.dex_listing': 'DEX Listing',
        'roadmap.staking_launch': 'Staking Launch',
        'roadmap.interactive_nfts': 'Interactive NFTs',
        'roadmap.ai_minigame': 'AI Minigame',
        'roadmap.charity_foundation': 'Charity Foundation',
        'roadmap.status_in_progress': 'In progress',
        'roadmap.status_coming_soon': 'Coming soon',
        'roadmap.status_planned': 'Planned',
        'roadmap.status_future': 'Future',
        'roadmap.status_vision': 'Vision',
        
        // Team Section
        'team_title': 'Our Team',
        'team_description': 'Meet the people behind QuokkaCoin',
        
        // Contact Section
        'contact_title': 'Contact Us',
        'contact_description': 'Get in touch with our team',
        
        // Common
        'learn_more': 'Learn More',
        'read_more': 'Read More',
        'view_more': 'View More',
        'language': 'Language',
        'app.title': 'QuokkaX',
        'nav.home': 'Home',
        'nav.tokenomics': 'Tokenomics',
        'nav.presale': 'Presale',
        'nav.roadmap': 'Roadmap',
        'nav.whitepaper': 'Whitepaper',
        'nav.connect_wallet': 'Connect Wallet',
        'nav.buy_with_card': 'Buy with Card',
        'nav.contact': 'Contact',
        'hero.title': 'The QuokkaX',
        'hero.subtitle': 'revolution has begun!',
        'hero.description': 'Participate in the exclusive presale of the most futuristic memecoin in the crypto universe.',
        'hero.countdown': 'Presale ends in:',
        'hero.days': 'Days',
        'hero.hours': 'Hours',
        'hero.minutes': 'Minutes',
        'hero.seconds': 'Seconds',
        
        // Staking Section
        'staking.title': 'Staking & Rewards',
        'staking.description': 'Stake your QOKX tokens and earn rewards. Claim your accumulated rewards anytime.',
        'staking.staking_title': 'Staking Pool',
        'staking.claim_title': 'Claim Rewards',
        'staking.apy': 'APY',
        'staking.total_staked': 'Total Staked',
        'staking.your_stake': 'Your Stake',
        'staking.available_rewards': 'Available Rewards',
        'staking.total_claimed': 'Total Claimed',
        'staking.next_claim': 'Next Claim',
        'staking.stake_now': 'Stake Now',
        'staking.claim_rewards': 'Claim Rewards',
        'staking.info_title': 'How it works',
        'staking.info_description': 'Stake your QOKX tokens to earn passive income. The longer you stake, the higher your rewards. Claim your rewards anytime.',
        'about.title': 'About QuokkaX',
        'about.description': 'QuokkaX is a revolutionary meme coin with real utility and purpose.',
        'about.feature1': 'Secure & Reliable',
        'about.feature1_desc': 'Built on BSC with audited smart contracts',
        'about.feature2': 'Community Driven',
        'about.feature2_desc': 'Governed by our active community',
        'about.feature3': 'Real Utility',
        'about.feature3_desc': 'More than just a meme coin',
        'roadmap.description': 'Our journey to revolutionize the meme coin space.',
        'roadmap.phase1': 'Phase 1',
        'roadmap.phase1_desc': 'Launch and Initial Marketing',
        'roadmap.phase2': 'Phase 2',
        'roadmap.phase2_desc': 'Community Growth',
        'roadmap.phase3': 'Phase 3',
        'roadmap.phase3_desc': 'Platform Development',
        'contact.title': 'Contact Us',
        'contact.description': 'Get in touch with our team.',
        'contact.email': 'Email',
        'contact.telegram': 'Telegram',
        'contact.twitter': 'Twitter',
        'contact.discord': 'Discord',
        
        // Presale Section
        'presale.title': 'Presale Information',
        'presale.description': 'Secure your QuokkaX tokens at the best price before the official launch',
        'presale.available_tokens': 'Available Tokens',
        'presale.rate': 'Rate:',
        'presale.tokens_available': 'Available Tokens',
        'presale.tokens_sold': 'Tokens Sold',
        'presale.sale_progress': 'Sale Progress',
        'presale.current_price': 'Current Price',
        'presale.next_price': 'Next Price',
        'presale.tokens_to_purchase': 'Number of tokens to purchase',
        'presale.buy_now': 'Buy Now',
        'presale.total': 'Total:',
        'presale.payment_methods': 'Payment Methods',
        'presale.copy_contract': 'Copy Contract Address',
        'presale.fee_note': 'Includes 2% buy tax and 2% sell tax for liquidity, development and ecosystem',
        'presale.quokkax_description': 'The crypto revolution has begun. Participate in the exclusive presale with the available payment methods.',
        'presale.benefits_title': 'Presale Benefits',
        'presale.benefit1': 'Exclusive low price',
        'presale.benefit2': 'Purchase volume bonuses',
        'presale.benefit3': 'Access to staking and NFTs',
        'presale.benefit4': 'Entry to minigame',
        'presale.benefit5': 'Holder raffles',
        'presale.security_title': 'Security & Trust',
        'presale.security1': 'Verified contract',
        'presale.security2': 'CertiK audit',
        'presale.security3': 'KYC with Assure DeFi',
        'presale.security4': 'Locked liquidity',
        'security': {
            title: 'Security',
            description: 'Our commitment to security and transparency',
            subtitle: 'Security Features',
            feature1: 'Verified contract',
            feature2: 'CertiK audit',
            feature3: 'KYC with Assure DeFi',
            feature4: 'Locked liquidity'
        },
        
        // FAQ Section
        'faq.title': 'Frequently Asked Questions',
        'faq.description': 'Common Questions About QuokkaX',
        'faq.what_is_quokkax': 'What is QuokkaX?',
        'faq.what_is_quokkax_answer': 'QuokkaX is a community-driven cryptocurrency inspired by the world\'s happiest animal, built on the Binance Smart Chain. We combine the fun aspects of memecoins with real utility and strong tokenomics.',
        'faq.how_to_buy': 'How can I buy QuokkaX?',
        'faq.how_to_buy_answer': 'You can buy QuokkaX through PancakeSwap by connecting your wallet and swapping BNB for QUOKKA. Check our \'How to Buy\' section for a detailed guide.',
        'faq.is_safe': 'Is QuokkaX safe?',
        'faq.is_safe_answer': 'Yes, our smart contract has been audited by leading security firms and our liquidity is locked. We prioritize the safety and security of our community\'s investments.',
        'faq.presale_start': 'When does the presale start?',
        'faq.presale_start_answer': 'The presale is already active. Early investors receive special bonuses based on contribution level.',
        'faq.security_funds': 'How do you ensure the security of funds?',
        'faq.security_funds_answer': 'We are in the process of auditing with CertiK, one of the leading blockchain security companies. Additionally, smart contracts include liquidity locking mechanisms.',
        'faq.token_trading': 'When will I be able to trade the token?',
        'faq.token_trading_answer': 'The token will be available for trading once the presale is completed and the audit is finalized. We estimate it will be listed on DEX in the next quarter.',
        'faq.token_utility': 'What utility will the token have?',
        'faq.token_utility_answer': 'The token will be used for staking with rewards, exclusive access to NFTs with benefits, participation in play-to-earn minigames, and ecosystem governance.',
        'faq.staking_program': 'How does the staking program work?',
        'faq.staking_program_answer': 'The staking program will offer different lock periods with variable APYs. The longer the commitment time, the higher the rewards.',
        
        // Footer Section
        'footer.title': 'QuokkaX',
        'footer.description': 'A revolutionary memecoin token with purpose. Participate in the presale and join our growing community.',
        'footer.buy_now': 'Buy Now',
        'footer.made_with_love': 'Made with love by the QuokkaX team',
        'footer.navigation': 'Navigation',
        'footer.home': 'Home',
        'footer.tokenomics': 'Tokenomics',
        'footer.presale': 'Presale',
        'footer.roadmap': 'Roadmap',
        'footer.faq': 'FAQ',
        'footer.resources': 'Resources',
        'footer.whitepaper': 'Whitepaper',
        'footer.smart_contract': 'Smart Contract',
        'footer.security': 'Security',
        'footer.community': 'Community',
        'footer.have_questions': 'Have questions?',
        'footer.copyright': 'QuokkaX. All rights reserved.',
        'footer.terms': 'Terms of Service',
        'footer.privacy': 'Privacy Policy'
    },
    es: {
        // Navigation
        'home': 'Inicio',
        'about': 'Sobre Nosotros',
        'tokenomics': 'Tokenomics',
        'roadmap': 'Hoja de Ruta',
        'team': 'Equipo',
        'contact': 'Contacto',
        'buy_now': 'Comprar Ahora',
        
        // Hero Section
        'hero_title': 'Bienvenido a QuokkaCoin',
        'hero_subtitle': 'La criptomoneda de próxima generación',
        
        // About Section
        'about_title': 'Sobre QuokkaCoin',
        'about_description': 'QuokkaCoin es una criptomoneda revolucionaria diseñada para el futuro.',
        
        // Tokenomics Section
        'tokenomics.title': 'Token Económico',
        'tokenomics.description': 'Profundiza en la estructura del token QuokkaX y explora el modelo económico detrás de tu inversión',
        'tokenomics.total_supply': 'Suministro Total',
        'tokenomics.tokens': 'Tokens QUOKKA',
        'tokenomics.buy_tax': 'Impuesto de Compra',
        'tokenomics.sell_tax': 'Impuesto de Venta',
        'tokenomics.presale': 'Preventa',
        'tokenomics.liquidity': 'Liquidez',
        'tokenomics.marketing': 'Marketing',
        'tokenomics.team': 'Equipo',
        'tokenomics.distribution': 'Distribución del Token',
        'tokenomics.transparent': 'Distribución Transparente y Justa',
        'tokenomics.total': 'Total',
        'tokenomics.details': 'Detalles del Token',
        'tokenomics.additional_info': 'Información Adicional',
        'tokenomics.token_name': 'Nombre del Token',
        'tokenomics.token_symbol': 'Símbolo del Token',
        'tokenomics.initial_price': 'Precio Inicial',
        'tokenomics.blockchain': 'Blockchain',
        'tokenomics.tax': 'Impuesto',
        'tokenomics.presale_allocation': 'Asignación de Preventa',
        'tokenomics.presale_allocation_desc': '40% del suministro total disponible durante la fase de preventa',
        'tokenomics.liquidity_lock': 'Bloqueo de Liquidez',
        'tokenomics.liquidity_lock_desc': 'Liquidez de la plataforma bloqueada para garantizar la estabilidad del proyecto',
        'tokenomics.vesting_period': 'Período de Vesting',
        'tokenomics.vesting_period_desc': 'Cliff de 6 meses con vesting lineal de 12 meses',
        'tokenomics.token_utility': 'Utilidad del Token',
        'tokenomics.token_utility_desc': 'Gobernanza, staking, acceso a NFTs y recompensas del ecosistema',
        'tokenomics.ecosystem': 'Ecosistema',
        'tokenomics.reserves': 'Reservas',
        'tokenomics.ecosystem_desc': 'Fondos asignados para el desarrollo y crecimiento del ecosistema',
        'tokenomics.reserves_desc': 'Reservas estratégicas para desarrollo futuro y alianzas',
        'tokenomics.presale_desc': 'Tokens asignados para la fase de preventa',
        'tokenomics.liquidity_desc': 'Tokens bloqueados para provisión de liquidez',
        'tokenomics.marketing_desc': 'Fondos asignados para marketing y promoción',
        'tokenomics.team_desc': 'Tokens asignados para desarrollo del equipo y recompensas',
        
        // Roadmap Section
        'roadmap_title': 'Hoja de Ruta',
        'roadmap_description': 'Nuestro viaje y planes futuros',
        'roadmap.title': 'Hoja de Ruta',
        'roadmap.presale': 'Preventa',
        'roadmap.certik_audit': 'Auditoría CertiK',
        'roadmap.dex_listing': 'Listado en DEX',
        'roadmap.staking_launch': 'Lanzamiento de Staking',
        'roadmap.interactive_nfts': 'NFTs Interactivos',
        'roadmap.ai_minigame': 'Minijuego con IA',
        'roadmap.charity_foundation': 'Fundación de Caridad',
        'roadmap.status_in_progress': 'En progreso',
        'roadmap.status_coming_soon': 'Próximamente',
        'roadmap.status_planned': 'Planificado',
        'roadmap.status_future': 'Futuro',
        'roadmap.status_vision': 'Visión',
        
        // Team Section
        'team_title': 'Nuestro Equipo',
        'team_description': 'Conoce al equipo detrás de QuokkaCoin',
        
        // Contact Section
        'contact_title': 'Contáctanos',
        'contact_description': 'Ponte en contacto con nuestro equipo',
        
        // Common
        'learn_more': 'Saber Más',
        'read_more': 'Leer Más',
        'view_more': 'Ver Más',
        'language': 'Idioma',
        'app.title': 'QuokkaX',
        'nav.home': 'Inicio',
        'nav.tokenomics': 'Tokenomics',
        'nav.presale': 'Preventa',
        'nav.roadmap': 'Hoja de Ruta',
        'nav.whitepaper': 'Documento Técnico',
        'nav.connect_wallet': 'Conectar Billetera',
        'nav.buy_with_card': 'Comprar con Tarjeta',
        'nav.contact': 'Contacto',
        'hero.title': 'La Revolución',
        'hero.subtitle': 'de QuokkaX ha comenzado!',
        'hero.description': 'Participa en la preventa exclusiva de la memecoin más futurista del universo cripto.',
        'hero.countdown': 'La preventa termina en:',
        'hero.days': 'Días',
        'hero.hours': 'Horas',
        'hero.minutes': 'Minutos',
        'hero.seconds': 'Segundos',
        
        // Staking Section
        'staking.title': 'Staking y Recompensas',
        'staking.description': 'Haz staking de tus tokens QOKX y gana recompensas. Reclama tus recompensas acumuladas en cualquier momento.',
        'staking.staking_title': 'Pool de Staking',
        'staking.claim_title': 'Reclamar Recompensas',
        'staking.apy': 'APY',
        'staking.total_staked': 'Total en Staking',
        'staking.your_stake': 'Tu Staking',
        'staking.available_rewards': 'Recompensas Disponibles',
        'staking.total_claimed': 'Total Reclamado',
        'staking.next_claim': 'Próximo Reclamo',
        'staking.stake_now': 'Hacer Staking',
        'staking.claim_rewards': 'Reclamar Recompensas',
        'staking.info_title': 'Cómo funciona',
        'staking.info_description': 'Haz staking de tus tokens QOKX para ganar ingresos pasivos. Cuanto más tiempo hagas staking, mayores serán tus recompensas. Reclama tus recompensas en cualquier momento.',
        'about.title': 'Sobre QuokkaX',
        'about.description': 'QuokkaX es una meme coin revolucionaria con utilidad y propósito real.',
        'about.feature1': 'Seguro y Confiable',
        'about.feature1_desc': 'Construido en BSC con contratos auditados',
        'about.feature2': 'Impulsado por la Comunidad',
        'about.feature2_desc': 'Gobernado por nuestra comunidad activa',
        'about.feature3': 'Utilidad Real',
        'about.feature3_desc': 'Más que una simple meme coin',
        'roadmap.description': 'Nuestro viaje para revolucionar el espacio de las meme coins.',
        'roadmap.phase1': 'Fase 1',
        'roadmap.phase1_desc': 'Lanzamiento y Marketing Inicial',
        'roadmap.phase2': 'Fase 2',
        'roadmap.phase2_desc': 'Crecimiento de la Comunidad',
        'roadmap.phase3': 'Fase 3',
        'roadmap.phase3_desc': 'Desarrollo de la Plataforma',
        'contact.title': 'Contáctanos',
        'contact.description': 'Ponte en contacto con nuestro equipo.',
        'contact.email': 'Correo Electrónico',
        'contact.telegram': 'Telegram',
        'contact.twitter': 'Twitter',
        'contact.discord': 'Discord',
        
        // Presale Section
        'presale.title': 'Información de Preventa',
        'presale.description': 'Asegura tus tokens QuokkaX al mejor precio antes del lanzamiento oficial',
        'presale.available_tokens': 'Tokens Disponibles',
        'presale.rate': 'Tasa:',
        'presale.tokens_available': 'Tokens Disponibles',
        'presale.tokens_sold': 'Tokens Vendidos',
        'presale.sale_progress': 'Progreso de Venta',
        'presale.current_price': 'Precio Actual',
        'presale.next_price': 'Próximo Precio',
        'presale.tokens_to_purchase': 'Número de tokens a comprar',
        'presale.buy_now': 'Comprar Ahora',
        'presale.total': 'Total:',
        'presale.payment_methods': 'Métodos de Pago',
        'presale.copy_contract': 'Copiar Dirección del Contrato',
        'presale.fee_note': 'Incluye 2% de impuesto de compra y 2% de impuesto de venta para liquidez, desarrollo y ecosistema',
        'presale.quokkax_description': 'La revolución cripto ha comenzado. Participa en la preventa exclusiva con los métodos de pago disponibles.',
        'presale.benefits_title': 'Beneficios de la Preventa',
        'presale.benefit1': 'Precio exclusivo bajo',
        'presale.benefit2': 'Bonificaciones por volumen de compra',
        'presale.benefit3': 'Acceso a staking y NFTs',
        'presale.benefit4': 'Acceso al minijuego',
        'presale.benefit5': 'Sorteos para holders',
        'presale.security_title': 'Seguridad y Confianza',
        'presale.security1': 'Contrato verificado',
        'presale.security2': 'Auditoría CertiK',
        'presale.security3': 'KYC con Assure DeFi',
        'presale.security4': 'Liquidez bloqueada',
        'security': {
            title: 'Seguridad',
            description: 'Nuestro compromiso con la seguridad y transparencia',
            subtitle: 'Características de Seguridad',
            feature1: 'Contrato verificado',
            feature2: 'Auditoría CertiK',
            feature3: 'KYC con Assure DeFi',
            feature4: 'Liquidez bloqueada'
        },
        
        // FAQ Section
        'faq.title': 'Preguntas Frecuentes',
        'faq.description': 'Preguntas Comunes Sobre QuokkaX',
        'faq.what_is_quokkax': '¿Qué es QuokkaX?',
        'faq.what_is_quokkax_answer': 'QuokkaX es una criptomoneda comunitaria inspirada en el animal más feliz del mundo, construida en Binance Smart Chain. Combina diversión con utilidad real y tokenomics sólidos.',
        'faq.how_to_buy': '¿Cómo comprar QuokkaX?',
        'faq.how_to_buy_answer': 'Puedes comprar QuokkaX en PancakeSwap conectando tu billetera y cambiando BNB por QUOKKA. Consulta nuestra guía de compra para más detalles.',
        'faq.is_safe': '¿Es seguro QuokkaX?',
        'faq.is_safe_answer': 'Sí, nuestro contrato está auditado por firmas líderes en seguridad y la liquidez está bloqueada. Priorizamos la seguridad de las inversiones de nuestra comunidad.',
        'faq.presale_start': '¿Cuándo empieza la preventa?',
        'faq.presale_start_answer': 'La preventa ya está activa. Los primeros inversores reciben bonificaciones según su nivel de contribución.',
        'faq.security_funds': '¿Cómo aseguran los fondos?',
        'faq.security_funds_answer': 'Estamos en auditoría con CertiK, líder en seguridad blockchain. Los contratos incluyen mecanismos de bloqueo de liquidez.',
        'faq.token_trading': '¿Cuándo podré operar?',
        'faq.token_trading_answer': 'El token estará disponible para operar tras completar la preventa y la auditoría. Estimamos listado en DEX para el próximo trimestre.',
        'faq.token_utility': '¿Qué utilidad tiene?',
        'faq.token_utility_answer': 'El token permite staking con recompensas, acceso a NFTs, participación en minijuegos play-to-earn y gobernanza del ecosistema.',
        'faq.staking_program': '¿Cómo funciona el staking?',
        'faq.staking_program_answer': 'El programa ofrece diferentes períodos de bloqueo con APYs variables. Mayor tiempo de compromiso, mayores recompensas.',
        
        // Footer Section
        'footer.title': 'QuokkaX',
        'footer.description': 'Un token memecoin revolucionario con propósito. Participa en la preventa y únete a nuestra creciente comunidad.',
        'footer.buy_now': 'Comprar Ahora',
        'footer.made_with_love': 'Hecho con amor por el equipo de QuokkaX',
        'footer.navigation': 'Navegación',
        'footer.home': 'Inicio',
        'footer.tokenomics': 'Tokenomics',
        'footer.presale': 'Preventa',
        'footer.roadmap': 'Hoja de Ruta',
        'footer.faq': 'Preguntas Frecuentes',
        'footer.resources': 'Recursos',
        'footer.whitepaper': 'Documento Técnico',
        'footer.smart_contract': 'Contrato Inteligente',
        'footer.security': 'Seguridad',
        'footer.community': 'Comunidad',
        'footer.have_questions': '¿Tienes preguntas?',
        'footer.copyright': 'QuokkaX. Todos los derechos reservados.',
        'footer.terms': 'Términos de Servicio',
        'footer.privacy': 'Política de Privacidad'
    }
}; 